/**
 * Normaliza texto para comparação: remove acentos, pontuação especial e converte para minúsculas.
 * "ç" → "c", "-", "." e outros símbolos são removidos para evitar falsos negativos no match.
 */
export function normalizeText(str: string): string {
  return str
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // remove diacríticos (acentos, cedilha decomposta, etc.)
    .replace(/[^\w\s]/g, "") // remove pontuação restante
    .toLowerCase();
}

/**
 * Gera a chave de busca removendo stop words do texto normalizado.
 * Garante que palavras muito frequentes não poluam o match.
 */
export function buildSearchKey(text: string, stopWords: string[]): string {
  let key = normalizeText(text);
  for (const word of stopWords) {
    key = key.replace(new RegExp(`\\b${word}\\b`, "g"), "");
  }
  return key.trim();
}
